// Configuration
const CONFIG = {

    SHEETS_API_URL: 'https://script.google.com/macros/s/AKfycbyExoGHRV3eB-Of0-rxPsbK8XLdHdO0Dc3vmDRCUIdQeaLIp3xeHPLWeue09MJ4ImIDww/exec', 
    
    APP_NAME: 'ACT Scoring Tool',

    // ACT Attempt Dates (Add your dates here)
    ACT_ATTEMPT_DATES: [
        'Dec 13, 2025',
        'Feb 14, 2026',
        'Apr 11, 2026',
        'Jun 13, 2026',
        'Jul 11, 2026'
    ],
    
    // Countries list
    COUNTRIES: [
        'United States',
        'Canada',
        'United Kingdom',
        'Australia',
        'India',
        'Other'
    ],
    
    // US States list (you can expand this)
    US_STATES: [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
        'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
        'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
        'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
        'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
        'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
        'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
        'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
        'West Virginia', 'Wisconsin', 'Wyoming'
    ],
    
    // Grades
    GRADES: [
        '9th Grade',
        '10th Grade',
        '11th Grade',
        '12th Grade'
    ],
    
    // Score conversion will be added later
    SCORE_CONVERSION: {}
};